import styled from 'styled-components';

import { ReactTableStyles } from '@nhl/nhl-breakaway-ui';

export const LoadingContainer = styled.div`
    display: flex;
    justify-content: center;
    padding-bottom: 64px;
    width: 100%;

    .inline-loader {
        background: ${({ theme }) => theme.Surface.primary};
    }
`;

export const ReactTableContainer = styled.div<{ $pinnedSize?: number }>`
    border-collapse: collapse;
    width: 100%;

    ${ReactTableStyles.CommonTableStyling};

    .rt-thead {
        scrollbar-width: none;
        overflow: scroll;
        z-index: 2;

        &::-webkit-scrollbar {
            display: none;
        }
    }

    .rt-table-container {
        ${({ $pinnedSize }) => $pinnedSize && ReactTableStyles.PinnedTableScrollShadows($pinnedSize)};
    }

    .rt-td,
    .rt-th {
        padding: 0 4px;
    }

    .paddedColumn {
        padding-left: 20px;
        padding-right: 20px;
    }
`;
